import React from 'react';
import { TextInput } from '../../../../Helpers/Inputs';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/core/styles';
import { Col, Form, Row } from 'react-bootstrap';
import InputMaxValue from '../../../../Helpers/Formatters/InputMaxValue';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

export default function IncomeDetails(props) {

    return (
        <React.Fragment>
            <Row>
                <Col md={6} className='pr-0'>
                <div className="d-flex">
                       <Form.Group className='w-100'>
                       <TextInput
                            name="totalIncome"
                            id="totalIncome"
                            value={props.state.totalIncome}
                            onChange={e => props.onFieldChange("totalIncome", e.target.value)}
                            label="Total Income Needed (Annual income needed)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps: { max: 500000 }
                            }}
                        />
                       </Form.Group>
                    <Tooltip title="Total Income Needed" className='button-hide' placement="right" enterTouchDelay={0}>
                        <LightTooltip><a onClick={props.setShowPopUp} className='mx-0' role='button'><InfoIcon color="primary" className='ml-1 mt-3' /></a>
                        </LightTooltip>
                    </Tooltip>
                    </div>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="spouseIncome"
                            id="spouseIncome"
                            value={props.state.spouseIncome}
                            onChange={e => props.onFieldChange('spouseIncome', e.target.value)}
                            label="Spouse/Other Income (All other annual income)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps: { max: 500000 }
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6} className='pr-0'>
                    <Form.Group>
                        <TextInput
                            name="incomeNeeded"
                            id="incomeNeeded"
                            value={props.state.incomeNeeded}
                            onChange={e => props.onFieldChange('incomeNeeded', e.target.value)}
                            label="Years of Income Needed"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps: { max: 30, isNumeric: true }
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/CoverageAmountPopUp/IncomeDetails.js